import { SupportQuestionModel } from "model/SupportQuestion.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = SupportQuestionModel[];

export const useDefaultObservableSupportQuestionModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectSupportQuestionModelArray extends BehaviorSubject<CurrentType> {}
